import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/showCode.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/c:code',
        name: 'home',
        component: HomeView
    },
    // {
    //     path: '/b:code',
    //     name: '影城核销端',
    //     component: () => import(/* webpackChunkName: "cinemaUse" */ '../views/cinemaUse.vue'),
    //     meta: {
    //         title: '影城核销端'
    //     }
    // },
    {
        path: '/verification',
        // path: '/b:code',
        name: '影城核销端',
        meta: {
            title: '浙影时代-影城核销端'
        },
        component: () => import(/* webpackChunkName: "CinemaVerification" */ '../views/CinemaVerification.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login.vue'),
    }
]

const router = new VueRouter({
    routes,
})

export default router
